import { render, staticRenderFns } from "./MoverDetail.vue?vue&type=template&id=0794bce6"
import script from "./MoverDetail.vue?vue&type=script&lang=js"
export * from "./MoverDetail.vue?vue&type=script&lang=js"
import style0 from "./MoverDetail.vue?vue&type=style&index=0&id=0794bce6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports